import { render, staticRenderFns } from "./testDB.vue?vue&type=template&id=3057428a"
import script from "./testDB.vue?vue&type=script&lang=js"
export * from "./testDB.vue?vue&type=script&lang=js"
import style0 from "./testDB.vue?vue&type=style&index=0&id=3057428a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports